import template from './confirmSupervisor.html';
import controller from './confirmSupervisor.controller';

let confirmSupervisor = {
  restrict: 'E',
  bindings: {
      onConfirm: '=',
      onError: '=',
      event: '=',
      details: '=',
      buttonText: '=',
      buttonStyle: '='
  },
  template,
  controller
};

export default confirmSupervisor;



// WEBPACK FOOTER //
// ./client/app/common/ui/confirmSupervisor/confirmSurpervisor.component.js